<template lang="pug">
.modal-card
  header.modal-card-head
    p.modal-card-title
      b(v-t="'customer.all_memberships'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body.has-background-light
    em-loading(v-if="!memberships.length" :active="loading" :is-full-page="false")
    .p-5(v-if="!memberships.length" style="min-height: 200px")
      p.has-text-centered(v-t="'memberships.no_packages'")
    div(v-else)
      customer-membership-view(v-for="membership in memberships" :key="membership._id" @click="openDetails(membership)" :value="membership._id")
  footer.modal-card-foot
    .buttons
      button.button.is-outlined(type="button" @click="$emit('close')" ) {{$t('actions.close')}}      
</template>
<script>
import MembershipDetails from './MembershipDetails.vue'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'CustomerAllMemberships',
  props: {
    customerId: {type: String, required: true}
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('memberships', ['customerMemberships']),
    memberships() {
      return this.customerMemberships(this.customerId)
    }
  },
  async created() {
    this.init()
  },
  methods: {
    ...mapActions('memberships', ['fetchCustomerMemberships']),
    async init() {
      this.loading = true
      try {
        await this.fetchCustomerMemberships(this.customerId)
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.loading = false
    },
    openDetails(membership) {
      this.$buefy.modal.open({
        parent: this,
        width: 640,
        props: {value: membership._id},
        hasModalCard: true,
        fullScreen: this.isMobile(),
        component: MembershipDetails,
        canCancel: ['outside', 'escape']
      })
    }
  }
}
</script>
